export const ADD_MINE_MANAGER = "Add Mine Manager";
export const UPDATE_MINE_MANAGER = "Update Mine Manager";
export const UPDATE_PERMITTEE = "Update Permittee";
export const CREATE_MINE_RECORD = "Create Mine Record";
export const UPDATE_MINE_RECORD = "Update Mine Record";
export const ADD_TAILINGS = "Add TSF";
export const EDIT_TAILINGS_REPORT = "Update TSF Report";
export const ADD_TAILINGS_REPORT = "Add TSF Report";
export const ADD_CONTACT = "Add New Contact";
export const EDIT_PARTY = (partyName) => `Update ${partyName}`;

export const PERSON = "PER";
export const ORGANIZATION = "ORG";

export const PARTY_NOT_FOUND = `If the party is not in the list above, please add a new person or company below`;
export const PERSON_NOT_FOUND =
  "If the party is not in the list above, please add a new person below";
export const COMPANY_NOT_FOUND =
  "If the company is not in the list above, please add a new company below";
export const EDIT_PARTY_RELATIONSHIP = "Edit Contact";

export const ADD_PERMIT = "Add a new permit";
export const PERMIT_AMENDMENT = "Add new amendment";
export const EDIT_PERMIT = "Edit Permit";

export const ADD_VARIANCE = (mineName) => `Add a Variance Application to ${mineName}`;
export const ADD_INCIDENT = (mineName) => `Record a Mine Incident at ${mineName}`;
export const EDIT_INCIDENT = (mineName) => `Edit a Mine Incident at ${mineName}`;

export const EDIT_REPORT = "Edit a Mine Report";
export const ADD_REPORT = "Add a Report";

export const ADD_NOW_REVIEW = "Add a Notice of Work Review";

export const CREATE_MINE_ALERT_RECORD = "Create Staff Alert";
export const EDIT_MINE_ALERT_RECORD = "Update Staff Alert";
export const PAST_MINE_ALERT_RECORD = "Past Alerts";

export const CREATE_MINE_ALERT_TEXT =
  "Creating a new staff alert will overwrite any previous alerts. Please use the edit alert option if you need to update an existing alert.";
export const EDIT_MINE_ALERT_TEXT =
  "You are updating an existing alert.  Please use the create new alert option if you need to create a new alert.";
